import { put, call } from 'redux-saga/effects';
import reduceStorefrontConfiguration from '../../actions/storefront/reduceStorefrontConfiguration';
import reduceUserInterface from "../../actions/storefront/reduceUserInterface";

export default function* getStorefrontConfigurationSaga() {
    const subfolderPrefix = process.env.REACT_APP_SUBFOLDER_NAME ? `/${process.env.REACT_APP_SUBFOLDER_NAME}` : '';
    const response = yield call(fetch, `${subfolderPrefix}/api/context/storefront-web-configuration`);
    const configuration = yield call([response, 'json']);
    yield put(reduceStorefrontConfiguration({ ...configuration.storefrontWebConfiguration }));
    yield put(reduceUserInterface(configuration.userInterface));
}
